module.exports = __webpack_public_path__ + "img/w3_css-official.80bc910e.svg";